import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Mail, ArrowLeft } from "lucide-react";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not send reset email");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <Card className="border-2 border-gray-900 rounded-xl">
        <CardContent className="p-8">
          <Link to="/login" className="inline-flex items-center gap-1 text-sm text-gray-700 hover:text-blue-700 mb-4" data-testid="forgot-back-to-login">
            <ArrowLeft className="w-4 h-4"/> Back to sign in
          </Link>
          <h1 className="font-heading text-3xl font-bold text-gray-900">Forgot your password?</h1>
          {submitted ? (
            <div className="mt-6 rounded-lg border-2 border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900" data-testid="forgot-submitted">
              <p className="font-semibold">Check your inbox.</p>
              <p className="mt-1">If an account exists for <b>{email}</b>, we&rsquo;ve sent a reset link. It expires in 1 hour and can only be used once.</p>
            </div>
          ) : (
            <>
              <p className="mt-2 text-gray-700">Enter the email you signed up with — we&rsquo;ll send you a one-time link to choose a new password.</p>
              <form onSubmit={onSubmit} className="mt-8 space-y-5">
                <div>
                  <Label htmlFor="fp-email" className="text-lg font-medium">Email</Label>
                  <Input id="fp-email" type="email" required value={email} onChange={e => setEmail(e.target.value)}
                    className="mt-2 h-12 border-2 border-gray-300 focus:border-blue-600" data-testid="forgot-email"/>
                </div>
                <Button type="submit" disabled={busy} className="w-full h-12 rounded-full bg-blue-600 hover:bg-blue-700" data-testid="forgot-submit">
                  <Mail className="w-4 h-4 mr-2"/>{busy ? "Sending…" : "Send reset link"}
                </Button>
              </form>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
